import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soccer',
  templateUrl: './soccer.component.html',
  styleUrls: ['./soccer.component.scss'],
})
export class SoccerComponent implements OnInit {
  title = 'app-soccer';

  ngOnInit(): void {}
}
